import { yupResolver } from "@hookform/resolvers/yup";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import AuthApi from "../../apis/auth.api";
import AppAlert from "../../components/AppAlert";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInput from "../../components/controls/AppInput";
import Spinner from "../../components/spinner/Spinner";
import TopPageBack from "../../components/TopPageBack";
import { RESULT_CODE } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import AppUtils from "../../utils";

const FindPassword = function () {
  const [openNoResult, setOpenNoResult] = useState(false);
  const [openIncorrectNumber, setOpenIncorrectNumber] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useState(() => {
    if (window.appBridge) {      
      window.appBridge.setEnableScroll && window.appBridge.setEnableScroll(false);          
    }
    return () => {
      if (window.appBridge) {        
        try {
          window.appBridge.setEnableScroll && window.appBridge.setEnableScroll(true);        
        } catch(e) {}        
      }
    }
  }, []);

  const schema = yup.object().shape({
    phoneNumber: yup.string().required(),
    id: yup.string().required(),
  });
  const { control, handleSubmit, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const removedDashPhoneNumber = AppUtils.replaceDash(data.phoneNumber);
    if (
      removedDashPhoneNumber.length >= 9 &&
      removedDashPhoneNumber.length <= 11 &&
      removedDashPhoneNumber.startsWith("010")
    ) {
      const submitData = {
        id: data.id,
        ownerPhone: removedDashPhoneNumber,
        ownerName: data.directorName,
        bizNo: AppUtils.replaceDash(data.businessCode)
      };
      try {
        setLoading(true);
        const res = await AuthApi.forgetPassword(submitData);
        if (res.data && res.data.result_code !== RESULT_CODE.NO_RESULT) {
          navigate(ROUTE_PATHS.VerifyCode, {
            state: {
              data: submitData,
              phoneNumber: data.phoneNumber,
              shopIdx: res.data.data.shopIdx,
              type: "find-password",
            },
          });
        } else {
          setOpenNoResult(true);
        }
      } catch (error) {
        setOpenNoResult(true);
      } finally {
        setLoading(false);
      }
    } else {
      setOpenIncorrectNumber(true);
    }
  };

  const values = watch();

  return (
    <div>
      <TopPageBack>
        <b>비밀번호 찾기</b>
      </TopPageBack>

      <div className="pt-4 px-5 scroll-box">
        <form onSubmit={handleSubmit(onSubmit)}>
          <AppInput
            control={control}
            name="businessCode"
            placeholder="사업자번호를 입력해 주세요."
            label="사업자등록번호"
            className="mb-5"
            type="number"
          />

          <AppInput
            control={control}
            name="id"
            placeholder="가입하신 아이디를 입력해 주세요."
            label="아이디"
            className="mb-5"
          />

          <AppInput
            control={control}
            name="directorName"
            placeholder="대표자 이름을 입력해 주세요."
            label="대표자명"
            className="mb-5"
          />

          <AppInput
            control={control}
            name="phoneNumber"
            placeholder="대표자 휴대폰 번호를 입력해 주세요."
            label="휴대폰 번호"
            maximum={11}
            isKoreaPhoneNumber
            type="number"
          />
            <div className="px-5 fixed w-full bottom-0 pb-2 bg-white left-0 z-[1]">
              <SolidBlueBtn
                disabled={
                  !values.phoneNumber ||
                  !values.id ||
                  loading
                }
                className="w-full mt-5  flex items-center justify-center"
                type="submit"
              >
                <Spinner isLoading={loading} />
                인증번호 받기
              </SolidBlueBtn>
            </div>
        </form>
      </div>

      <AppAlert
        title="계정을 찾을 수 없어요."
        desc="입력한 정보가 맞는지 확인하거나 <br /> 매장 담당자에게 연락해 주세요."
        open={openNoResult}
        onOk={() => setOpenNoResult(false)}
        okText="확인"
        type="error"
      />

      <AppAlert
        title="휴대폰 번호가 올바르지 않아요."
        desc="번호를 다시 한번 확인해 주세요."
        open={openIncorrectNumber}
        onOk={() => setOpenIncorrectNumber(false)}
        okText="확인"
        type="error"
      />
    </div>
  );
};
export default FindPassword;
